/**
 * Source of coaching sessions
 * Mostly in parity with the Python constants.py file
 */

export const CHATSOURCE = {
    ANONYMOUS_FEEDBACK: "anonymous_feedback",
    CONNECTION_CARD: "connection_card",
    CONNECTION_DETAIL: "connection_detail",
    FILE_UPLOAD_LIMIT: "file_upload_limit",
    HOME_ACTION_ITEMS: "home_action_items",
    HOME_CHAT_MESSAGE: "home_chat_message",
    HOME_DEFAULT: "home_default",
    HOME_FOLLOW_UP: "home_follow_up",
    HOME_INSIGHTS_EMPTY: "home_insights_empty",
    HOME_INSIGHTS: "home_insights",
    HOME_MEET_NADIA: "home_meet_nadia",
    HOME_PAST_CONVERSATIONS: "home_past_conversations",
    HOME_ROLE_PLAY: "home_role_play",
    HOME_SUGGESTED_TOPICS: "home_suggested_topics",
    HOME_WRAPPED: "home_wrapped",
    LEFT_SIDEBAR: "left_sidebar",
    NEW_USER_CHECKLIST: "new_user_checklist",
    ONBOARDING_DEEP_DIVE: "onboarding_deep_dive",
    PAST_CONVERSATIONS_SEARCH: "past_conversations_search",
    PAST_CONVERSATIONS: "past_conversations",
    PAST_CONVERSATIONS_INSIGHT: "past_conversations_insight",
    PENDING_ACTION_ITEMS: "pending_action_items",
    PERFORMANCE_REVIEW: "performance_review",
    TRENDING_ORG_PROMPT: "trending_org_prompt",
    HOME_USER_FEEDBACK: "home_user_feedback",
    CALENDAR_DEBRIEF: "calendar_debrief",
    CALENDAR_PREPARE: "calendar_prepare",
    DEVELOPMENT_JOURNEYS: "development_journeys",
    RETURN_TO_CHAT: "return_to_chat",
    CHAT_BAR_BUTTON: "chat_bar_button",
    PERSPECTIVE_ASSESSMENT: "perspective_assessment",
};

export const HOMEPAGE_CARD_LOCATION = {
    HOME: "home",
    MOMENTS: "moments",
    CHAT_HISTORY: "chat_history",
};

export const CHAT_MESSAGE_CONTROLS_LOCATION = {
    HOMEPAGE: "homepage",
    CHAT_DETAIL: "chat_detail",
    CONNECTION_DETAIL: "connection_detail",
    FEEDBACK_CHAT: "feedback_chat",
    REVIEW_RESPONSE: "review_response",
    ONBOARDING: "onboarding",
};

export const FILE_UPLOAD_LIMIT = 10;

export const CHAT_ERROR = {
    TRANSCRIPTION_EXHAUSTED: "We're having issues transcribing your audio message. Please try again later.",
    RECORDING_DEFAULT: "We're having issues recording your audio message. Please try again later.",
    SEND_FAILURE: "We're having issues sending your message. Please try again later.",
    NO_SPEECH_DETECTED: "I didn't quite catch that. Please try again.",
};

export enum ACCESS {
    PRIVATE = "private",
    INVITED_ORG_MEMBERS = "invited_org_members",
    ORGANIZATION = "organization",
}

export const ACCESS_BUTTON_LABELS: Record<ACCESS, string> = {
    [ACCESS.PRIVATE]: "Private",
    [ACCESS.INVITED_ORG_MEMBERS]: "Invited",
    [ACCESS.ORGANIZATION]: "Org-wide",
};
